import Plotly from "react-plotly.js"
import {Skeleton} from "primereact/skeleton"

import {useMetricsQuery} from "./util.jsx"

const ROW_HEIGHT = 34
const MIN_CHART_HEIGHT = 320

const PositionChart = ({rows, isLoading}) => {
    const sorted = [...rows].sort((a, b) => a.count - b.count)
    const dTicksValue = () => {
        const maxValue = rows.length > 0 ? Math.max(...rows.map((r) => r.count)) : 0
        if (maxValue <= 10) return 1
        const rawDtick = Math.ceil(maxValue / 20)
        return Math.ceil(rawDtick / 5) * 5
    }

    const traces = [
        {
            x: sorted.map((r) => r.count),
            y: sorted.map((r) => r.position_name),
            type: "bar",
            orientation: "h",
            marker: {color: "rgba(21,122,142,1)"},
            hovertemplate: "%{x} orientees<extra>%{y}</extra>",
        },
    ]

    const layout = {
        xaxis: {title: "Orientees", rangemode: "tozero", dtick: dTicksValue(), tickformat: "d"},
        yaxis: {automargin: true, ticklabelstandoff: 12},
        margin: {l: 10, r: 20, t: 20, b: 50},
        showlegend: false,
        height: Math.max(MIN_CHART_HEIGHT, sorted.length * ROW_HEIGHT + 80),
    }

    const config = {displayModeBar: false, responsive: true}

    return (
        <div className="card card-xl-stretch mb-xl-8">
            <div className="card-header border-0 pt-5">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold fs-2 text-gray-900">Orientee Count by Position</span>
                    <span className="fs-6 fw-semibold text-gray-700">Active, paused, and completed orientations</span>
                </h3>
            </div>
            <div className="card-body pt-5">
                {isLoading ? (
                    <Skeleton className="w-100 h-400px" />
                ) : sorted.length === 0 ? (
                    <div className="text-muted text-center py-10">No orientees match the current filters.</div>
                ) : (
                    <Plotly data={traces} layout={layout} config={config} style={{width: "100%"}} />
                )}
            </div>
        </div>
    )
}

const MetricsDemographics = ({filters = {}}) => {
    // const {data, isLoading, error} = useMetricsQuery("demographics", filters, {
    //     by_position: [],
    //     totals: {orientations: 0},
    // })

    console.log(filters)

    const data2027 = {
        "by_position": [
            {
                "position_name": "Clinical Nurse I",
                "count": 939
            },
            {
                "position_name": "Clinical Nurse II",
                "count": 863
            },
            {
                "position_name": "Nurse Graduate",
                "count": 180
            },
            {
                "position_name": "Licensed Practical Nurse",
                "count": 61
            },
            {
                "position_name": "Special Care Nurse I",
                "count": 49
            },
            {
                "position_name": "Special Care Nurse II",
                "count": 15
            },
            {
                "position_name": "Registered Nurse",
                "count": 8
            },
            {
                "position_name": "Senior Clinical Nurse II",
                "count": 1
            }
        ],
        "totals": {
            "orientations": 2116
        }
    }

    const data2026 = {
        "by_position": [
            {
                "position_name": "Clinical Nurse II",
                "count": 388
            },
            {
                "position_name": "Clinical Nurse I",
                "count": 340
            },
            {
                "position_name": "Nurse Graduate",
                "count": 80
            },
            {
                "position_name": "Licensed Practical Nurse",
                "count": 26
            },
            {
                "position_name": "Special Care Nurse I",
                "count": 21
            },
            {
                "position_name": "Special Care Nurse II",
                "count": 5
            },
            {
                "position_name": "Registered Nurse",
                "count": 1
            }
        ],
        "totals": {
            "orientations": 861
        }
    }

    const data2025 = {
        "by_position": [
            {
                "position_name": "Clinical Nurse I",
                "count": 248
            },
            {
                "position_name": "Clinical Nurse II",
                "count": 247
            },
            {
                "position_name": "Nurse Graduate",
                "count": 53
            },
            {
                "position_name": "Licensed Practical Nurse",
                "count": 19
            },
            {
                "position_name": "Special Care Nurse I",
                "count": 10
            },
            {
                "position_name": "Special Care Nurse II",
                "count": 8
            }
        ],
        "totals": {
            "orientations": 585
        }
    }

    const data2024 = {
        "by_position": [
            {
                "position_name": "Clinical Nurse I",
                "count": 115
            },
            {
                "position_name": "Clinical Nurse II",
                "count": 68
            },
            {
                "position_name": "Nurse Graduate",
                "count": 16
            },
            {
                "position_name": "Licensed Practical Nurse",
                "count": 10
            },
            {
                "position_name": "Special Care Nurse I",
                "count": 9
            },
            {
                "position_name": "Special Care Nurse II",
                "count": 1
            }
        ],
        "totals": {
            "orientations": 219
        }
    }

    const data2023 = {
        "by_position": [
            {
                "position_name": "Clinical Nurse I",
                "count": 110
            },
            {
                "position_name": "Clinical Nurse II",
                "count": 54
            },
            {
                "position_name": "Nurse Graduate",
                "count": 15
            },
            {
                "position_name": "Licensed Practical Nurse",
                "count": 4
            },
            {
                "position_name": "Special Care Nurse I",
                "count": 2
            }
        ],
        "totals": {
            "orientations": 185
        }
    }

    const isLoading = false
    const error = null

    let data = {};
    if (filters.fiscal_year === 2027) {
        data = data2027;
    } else if (filters.fiscal_year === 2026) {
        data = data2026;
    } else if (filters.fiscal_year === 2025) {
        data = data2025;
    } else if (filters.fiscal_year === 2024) {
        data = data2024;
    } else if (filters.fiscal_year === 2023) {
        data = data2023;
    }


    if (error) return <div className="alert alert-danger">Unable to load demographics.</div>

    return (
        <>
            <h2 className="fw-bold mb-8">Demographics</h2>
            <div className="row g-5 g-xl-8">
                <div className="col-12">
                    <PositionChart rows={data.by_position} isLoading={isLoading} />
                </div>
            </div>
        </>
    )
}

export default MetricsDemographics
